import { ReportHandler } from "web-vitals";

const reportWebVitals = (_onPerfEntry?: ReportHandler) => {
  return undefined;
};

export default reportWebVitals;
